import { applyCNPJMask, removeCNPJMask } from "@/core/common/utils";

type CNPJData = {
  completo: string | null;
  raiz?: string | number;
  filial?: string | number;
};

const DEFAULT_VALUE = "CNPJ não encontrado";

export default class CNPJ {
  completo: string | null;
  raiz?: string | number;
  filial?: string | number;

  private constructor(props: CNPJData) {
    this.completo = props.completo;
    this.raiz = props.raiz;
    this.filial = props.filial;

    Object.freeze(this);
  }

  static create(cnpjData: CNPJData): CNPJ {
    return new CNPJ(cnpjData);
  }

  static getDefaultCNPJErrorMessage(): string {
    return DEFAULT_VALUE;
  }

  getValue(): CNPJData {
    return this;
  }

  unmask(): string {
    return removeCNPJMask(this.completo) || DEFAULT_VALUE;
  }

  mask(): string {
    return this.completo ? applyCNPJMask(this.completo) : DEFAULT_VALUE;
  }
}
